var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sec-footer"},[_c('QACON',{attrs:{"data-anchor":"QACON","qa-list":_vm.qaList}}),_c('COOPERATE',{attrs:{"cooperate-img":_vm.cooperateImg}}),_c('EXPLAIN',{attrs:{"explain-desc":_vm.explainDesc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }